import firebase from "../firebase";

export default function({ officeId, formStage }) {
    return firebase.functions().httpsCallable("allFunctions")({
        funcRole: "patientTrackingUser",
        funcName: "createCheckoutStages",
        data: { officeId, formStage }
    });
}
